import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class RemarkBanner extends PureComponent {
  static propTypes = {
    text: PropTypes.string,
    href: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    location.href = this.props.href;
  }

  render() {
    const { text, href } = this.props;

    return (
      <div
        className="row"
        onClick={this.handleClick}
        style={{ cursor: "pointer" }}
      >
        <div className="columns small-12 medium-12">
          <div style={{ display: "flex" }}>
            <a
              className="remarkText"
              href={href}
              title="Gå til meteorologens kommentar"
            >
              <div dangerouslySetInnerHTML={{ __html: text }} />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

RemarkBanner.defaultProps = { href: "Vagtchefens_rubrik" };
export default RemarkBanner;
